export const formName = 'membership-details-form';

export enum SRMembershipOrganizationDetailsFormFields {
  Organization = 'organization',
  SubscriptionType = 'subscriptionType',
  MembershipPlanId = 'membershipPlanId',
  EffectiveDate = 'effectiveDate',
  ExpirationDate = 'expirationDate',
}
